import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getTransmissionParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'transmissionParts';

export const transmissionPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTransmissionParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTransmissionParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearTransmissionParts } = transmissionPartsSlice.actions;

export const transmissionParts = transmissionPartsSlice.reducer;
